export default require('../table/Input').default.concat();


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/dataItems/form/Input.js
// module id = 276
// module chunks = 0